import { render, staticRenderFns } from "./Dingdingxiaoshou.vue?vue&type=template&id=30e529d2&scoped=true&"
import script from "./Dingdingxiaoshou.vue?vue&type=script&lang=js&"
export * from "./Dingdingxiaoshou.vue?vue&type=script&lang=js&"
import style0 from "./Dingdingxiaoshou.vue?vue&type=style&index=0&id=30e529d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e529d2",
  null
  
)

export default component.exports